export function Notice() {
  return (
    <div>
      <div>
        <img src="./attention.png" alt="uwaga" style={{ width: "260px" }} />
      </div>
      <p>
        <h2>Gabinet Okulistyczny</h2>
        <div>”Osiedle Magnolia Park”, Szczecin, ul. Klonowica 43/1</div>
        <div>Godziny przyjęć: czwartek - 15:30 – 17:30</div>
      </p>
      <p>
        <h2>Rejestracja telefoniczna</h2>
        <div>Telefon bezpośrednio do dr Anny Piekarskiej:</div>
        <div style={{ fontSize: "18px" }}>
          <b>532 307 632</b>
        </div>
        <div>(rejestracja - wtorek i środa w godz. 17:00 – 19:00)</div>
        <br />
        <div>Telefon do gabinetu:</div>
        <div style={{ fontSize: "18px" }}>
          <b>785 309 030</b>
        </div>
        <div>
          (rejestracja od poniedziałku do czwartku w godz. 15:00 – 18:00)
        </div>
      </p>
    </div>
  );
}
